import { render, staticRenderFns } from "./FeesForSecurityForm.vue?vue&type=template&id=5d6c671e&scoped=true&"
import script from "./FeesForSecurityForm.vue?vue&type=script&lang=js&"
export * from "./FeesForSecurityForm.vue?vue&type=script&lang=js&"
import style0 from "./FeesForSecurityForm.vue?vue&type=style&index=0&id=5d6c671e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6c671e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d6c671e')) {
      api.createRecord('5d6c671e', component.options)
    } else {
      api.reload('5d6c671e', component.options)
    }
    module.hot.accept("./FeesForSecurityForm.vue?vue&type=template&id=5d6c671e&scoped=true&", function () {
      api.rerender('5d6c671e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/dialog/calculation/FeesForSecurityForm.vue"
export default component.exports